// src/Admin/AdminLayout.js
import React, { useMemo } from "react";
import { Box, Button } from "@mui/material";
import { useHistory, useLocation } from "react-router-dom";

import TopNav from "../navigation/TopNav";
import SectionNav from "../navigation/SectionNav";
import MainContent from "../navigation/MainContent";
import { NAV } from "../navigation/navigation.config";

function getActiveSectionKeySafe(nav, pathname) {
  if (!nav || !nav.sections) return "dashboard";

  // 1) Match by top tab base
  for (const tab of nav.top || []) {
    if (pathname === tab.base) return tab.key;
    if (pathname.startsWith(tab.base + "/")) return tab.key;
  }

  // 2) Match by section item paths
  for (const [sectionKey, section] of Object.entries(nav.sections)) {
    for (const item of section.items || []) {
      if (pathname === item.path) return sectionKey;
      if (pathname.startsWith(item.path + "/")) return sectionKey;
    }
  }

  return "dashboard";
}

export default function AdminLayout({ children }) {
  const history = useHistory();
  const location = useLocation();

  const nav = NAV.admin;

  const activeSectionKey = useMemo(
    () => getActiveSectionKeySafe(nav, location.pathname),
    [nav, location.pathname]
  );

  const section =
    nav.sections?.[activeSectionKey] ||
    nav.sections?.dashboard;

  const handleLogout = async () => {
    try {
      await fetch("/api/logout", {
        method: "POST",
      });
    } catch (e) {
      console.error("Admin logout failed:", e);
    } finally {
      localStorage.removeItem("token");
      localStorage.removeItem("adminToken");
      history.push("/admin/sign-in");
    }
  };

  const rightSlot = (
    <Button color="inherit" onClick={handleLogout}>
      Logout
    </Button>
  );

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        width: "100%",
        minWidth: 0,
        backgroundColor: "#f8fafc",
        overflowX: "hidden",
      }}
    >
      <TopNav
        navTop={nav.top}
        appTitle="HaggleFreight Admin"
        rightSlot={rightSlot}
        activeKey={activeSectionKey}
      />

      <Box
        sx={{
          display: "flex",
          flex: 1,
          minHeight: 0,
          minWidth: 0,
          width: "100%",

          // CRITICAL:
          // Phone = section navigation above content.
          // Desktop = section navigation beside content.
          flexDirection: {
            xs: "column",
            md: "row",
          },
        }}
      >
        <SectionNav
          title={section?.title || "Menu"}
          items={section?.items || []}
        />

        <MainContent>{children}</MainContent>
      </Box>
    </Box>
  );
}
